import { render } from "./UiPrivacyPolicy.vue?vue&type=template&id=fbbc5bd6&ts=true&lang=pug"
import script from "./UiPrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiPrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__